import { findFirstUnmetGroupLimits } from '../../helpers/limitations';
import { type Guard } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Determines whether there are any unmet minimum limit groups within the given context.
 *
 * It evaluates the modifications against their respective modification limits
 * and checks if any group limit remains unmet.
 */
export const checkIfHasUnmetMinLimitGroup: Guard = function (args): boolean {
  const { context } = args;

  const { modifications, modificationLimits } = context;

  // ─── Missing Data ────────────────────────────────────────────────────

  const hasMissingData = !modifications || !modificationLimits;

  if (hasMissingData) {
    return false;
  }

  // ─────────────────────────────────────────────────────────────────────

  const { active } = modifications;

  const firstUnmetGroupLimits = findFirstUnmetGroupLimits(
    active,
    modificationLimits,
  );

  return Boolean(firstUnmetGroupLimits);
};
